import { useNavigate } from 'react-router-dom';
import { ListChecks } from 'lucide-react';
import { Badge } from '@proerp/ui';
import { formatDate } from '@/lib/format';
import { useMyProjectTasks } from '@/features/projects/projectTasksApi';
import { TaskCard, TaskRow } from './TaskCard';

/**
 * Meine offenen Projektaufgaben über alle Projekte (ADR 0062). Datensatz-Filter
 * passiert serverseitig (nur `assigneeUserId === ctx.userId`) — hier nur Anzeige.
 * Überfällige/bald fällige Deadlines werden farblich hervorgehoben (nie nur Farbe:
 * Text bleibt explizit „überfällig"/„fällig").
 */
export function MyTasksWidget() {
  const navigate = useNavigate();
  const query = useMyProjectTasks();
  const tasks = query.data?.data ?? [];

  return (
    <TaskCard
      title="Meine offenen Aufgaben"
      icon={ListChecks}
      isLoading={query.isLoading}
      isEmpty={tasks.length === 0}
      emptyText="Dir sind aktuell keine offenen Aufgaben zugewiesen."
    >
      {tasks.slice(0, 8).map((task) => {
        const due = task.deadline ? new Date(task.deadline).getTime() : null;
        const isOverdue = due !== null && due < Date.now();
        const isDueSoon = due !== null && !isOverdue && due <= Date.now() + 7 * 24 * 60 * 60 * 1000;
        return (
          <TaskRow
            key={task.id}
            onClick={() => navigate(`/projekte/${task.projectId}`)}
            left={
              <>
                <span className="text-foreground">{task.title}</span>
                <span className="ml-2 font-mono text-xs text-muted-foreground">{task.projectCode}</span>
                <span className="ml-2 text-xs text-muted-foreground">{task.projectName}</span>
              </>
            }
            right={
              task.deadline ? (
                <Badge tone={isOverdue ? 'danger' : isDueSoon ? 'warning' : 'neutral'}>
                  {isOverdue ? 'überfällig' : 'fällig'} {formatDate(task.deadline)}
                </Badge>
              ) : (
                <span className="text-xs text-muted-foreground">ohne Termin</span>
              )
            }
          />
        );
      })}
    </TaskCard>
  );
}
